import React, { useState, useEffect, useRef, useCallback } from "react";
import "./styles.scss";
import UserTag from "../../../shared/UserTag";
import _ from "lodash";
import FullPageSpinner from "../../../../FullPageSpinner";
import ViewType from "../../../shared/ViewType";
import FollowButton from "../../../WhoToFollow/FollowButton";
import { ReactComponent as NewMessage } from "../../../../..//public/icons/UserProfile/newMessage_grey.svg";
import SendNewMessage from "../../../shared/SendNewMessage";
import RollOver from "../../../../RollOver";
const PAGE_SIZE = 10;

export default ({ displayMessage, type, index_func, match }) => {
  const [page, setPage] = useState(0);
  const [viewType, setViewType] = useState("list");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastCount, setLastCount] = useState(0);

  const shouldDisplayMessage = displayMessage && type === "followers";

  const [tooltip, setTooltip] = useState("copy link");

  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && lastCount === PAGE_SIZE) {
          setPage((p) => p + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, lastCount]
  );

  // this useffect will handle loading more
  useEffect(() => {
    if (page == 0) return;
    setLoading(true);
    index_func(page, PAGE_SIZE)
      .then(({ data: { followings, followers, users } }) => {
        setLoading(false);
        const newUsers = users || followings || followers;
        setLastCount(newUsers.length);
        setUsers((prevUsers) => (_.isArray(prevUsers) ? [...prevUsers, ...newUsers] : newUsers));
      })
      .catch((err) => console.log("err ->", err));
  }, [page]);

  // this useEffect will handle landing page
  useEffect(() => {
    setUsers(null);
    index_func(0, PAGE_SIZE)
      .then(({ data: { followings, followers, users } }) => {
        const newUsers = users || followings || followers;
        setLastCount(newUsers.length);
        setUsers(newUsers);
      })
      .catch((err) => console.log("err ->", err));
  }, [match.path]);

  const switchView = (view) => {
    setViewType(view);
  };

  return (
    <div id="user-lists" className={`users ${viewType === "grid" ? "grid-view" : "list-view"}`}>
      {_.isNull(users) ? (
        <FullPageSpinner className="mt-3" />
      ) : (
        <React.Fragment>
          <ViewType onSwitchView={switchView} />
          {viewType === "list" ? (
            users.map((user, index) => (
              <div className="user d-flex align-items-center">
                <UserTag forwardedRef={users.length === index + 1 ? lastElementRef : null} user={user} className="text-light w-100" />
                <FollowButton user={user} varient="primary" className="btn-md" />
                {shouldDisplayMessage && (
                  <div className="sms">
                    <RollOver type="follower" text="Send a Direct Message" className="tooltip-for-profile-clipboard-modal">
                      <SendNewMessage username={user.slug} id={user.id} className="icon-btn btn btn-outline-light message-btn">
                        <NewMessage />
                      </SendNewMessage>
                    </RollOver>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="profile-grid-view">
              {users.map((user, index) => (
                <div className="user d-flex align-items-center text-center">
                  <UserTag forwardedRef={users.length === index + 1 ? lastElementRef : null} user={user} className="text-light w-100" />
                </div>
              ))}
            </div>
          )}
          {loading ? <FullPageSpinner className="h-50 mt-3" /> : null}
        </React.Fragment>
      )}
    </div>
  );
};
